import { Component, computed, input } from '@angular/core';
import { WorkflowOperator } from '@devices/models';

@Component({
  selector: 'avs-incident-rule-operator',
  templateUrl: './incident-rule-operator.component.html',
})
export class IncidentRuleOperatorComponent {
  operator = input.required<WorkflowOperator>();

  protected operatorSymbols = computed(() => this.operator().split(''));
}
